import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@material-ui/core'
// import { useHistory } from 'react-router'

import Back from 'assets/images/nft/wallpaper.png'
import Bg1 from 'assets/images/nft/olafback1.png'
import Bg2 from 'assets/images/nft/olafback2.png'
import BackMobile from 'assets/images/nft/smallwall.png'
import Button1 from 'assets/images/token/join.png'
import useWindowDimensions from 'hooks/useDimensions'
// import ModelBrowseModal from 'components/Modals/ModelBrowseModal'

const NFT: React.FC = () => {
    // const history = useHistory()
    const screenWidth = useWindowDimensions().width
    const [isMobile, setIsMobile] = useState(false)
    // const [open3DModel, setOpen3DModel] = useState(false)

    useEffect(() => {
        screenWidth > 767 ? setIsMobile(false) : setIsMobile(true)
    }, [screenWidth])
    return (
        <StyledContainer>
            {!isMobile &&
                <OlafText>3D Model NFTs will <span>coming soon</span>!</OlafText>
            }
            <PreviewBox textAlign='center'>
                <img src={Bg1} alt='' />
                <img src={Bg2} alt='' />
                <video src='/video/olaf.mp4' autoPlay muted loop
                    // onClick={() => setOpen3DModel(true)}
                />
            </PreviewBox>
            <Box display='flex' justifyContent='center'>
                <JoinButton component='img' {...{ src: Button1 }} onClick={() => window.open('https://forms.gle/iwBvomru7fupQxKq7')} />
            </Box>
            {/* <ModelBrowseModal open={open3DModel} setOpen={setOpen3DModel} /> */}
        </StyledContainer>
    )
}

const PreviewBox = styled(Box)`
    position: relative;
    >img:first-of-type {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    >img:nth-of-type(2) {
        position: absolute;
        bottom:0;
        right: 38%;
    }
    >video {
        position: relative;
        /* cursor: pointer; */
        width: 100%;
        border-radius: 50%;
        @media (min-width: 475px) {
            width: 474px;
        }
    }
`

const JoinButton = styled(Box)`
    margin-top: 39.88px;
    height: 84px;
    cursor: pointer;
    pointer-events: initial;
`

const OlafText = styled(Box)`
    font-weight: bold;
    font-size: 50px;
    line-height: 109%;
    color: #3F78BD;
    text-align: center;
    span {
        font-weight: bold;
        font-size: 50px;
        line-height: 109%;
        color: #f6669e;
    }
`

const StyledContainer = styled(Box)`
    padding-top: 63px;
    padding-bottom: 44px;
    background-image: url(${BackMobile});
    @media (min-width: 767px) {
        background-image: url(${Back});
    }
    background-size: 100% 100%;
    background-repeat: no-repeat;
    /* background-image: linear-gradient(90deg, #bfd9ee 0%, #eaf3f9 50%, #bfd9ee 100%); */
`

export default NFT